import { render, staticRenderFns } from "./PickingsUnitInCampaign.vue?vue&type=template&id=68744ad7"
import script from "./PickingsUnitInCampaign.vue?vue&type=script&lang=js"
export * from "./PickingsUnitInCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports